import SEOHead from "@/components/SEOHead";
import { Shield, ExternalLink } from "lucide-react";

export default function ICOCertificatePage() {
  return (
    <div>
      <SEOHead title="ICO Registration" description="Can Do Payments Ltd is registered with the Information Commissioner's Office (ICO) under registration reference ZB560299." path="/ico-certificate" />
      <section className="hero-gradient py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight">ICO Registration Certificate</h1>
          <p className="text-sm text-brand-grey mt-2">Data Protection Registration</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-50 border border-brand-light-grey rounded-2xl p-8 sm:p-10 space-y-6">
            <div className="flex items-center gap-3 mb-4">
              <Shield size={28} className="text-brand-aqua" />
              <div>
                <h2 className="font-heading text-xl font-bold text-brand-black">Data Protection Registration</h2>
                <p className="text-sm text-brand-grey">Information Commissioner&apos;s Office</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-white border border-brand-light-grey rounded-xl p-4">
                <p className="text-xs text-brand-grey uppercase tracking-wider mb-1">Organisation</p>
                <p className="text-sm font-bold text-brand-black">Can Do Payments Ltd</p>
              </div>
              <div className="bg-white border border-brand-light-grey rounded-xl p-4">
                <p className="text-xs text-brand-grey uppercase tracking-wider mb-1">Registration Reference</p>
                <p className="text-sm font-bold text-brand-black">ZB560299</p>
              </div>
              <div className="bg-white border border-brand-light-grey rounded-xl p-4">
                <p className="text-xs text-brand-grey uppercase tracking-wider mb-1">Date Registered</p>
                <p className="text-sm font-bold text-brand-black">22 June 2023</p>
              </div>
              <div className="bg-white border border-brand-light-grey rounded-xl p-4">
                <p className="text-xs text-brand-grey uppercase tracking-wider mb-1">Registration Expires</p>
                <p className="text-sm font-bold text-brand-black">21 June 2027</p>
              </div>
            </div>
            <div className="bg-white border border-brand-light-grey rounded-xl p-4">
              <p className="text-xs text-brand-grey uppercase tracking-wider mb-1">Registered Address</p>
              <p className="text-sm text-brand-black">Suite 12 The Technology Centre, Inward Way, Ellesmere Port, CH65 3EN</p>
            </div>
            <div className="flex flex-wrap gap-3 pt-2">
              <a href="https://ico.org.uk/ESDWebPages/Entry/ZB560299" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-aqua hover:text-brand-aqua-dark transition-colors">
                Verify on ICO register <ExternalLink size={14} />
              </a>
              <a href="/docs/ico.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-aqua hover:text-brand-aqua-dark transition-colors">
                Download certificate (PDF) <ExternalLink size={14} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
